module.exports = "/_next/static/images/53a7f6712e14a61ba85fdcfcbb9b7d3f-qed.png.webp";